export type ArtTransform = {
  x: number; y: number; width: number; height: number;
  scaleX: number; scaleY: number; rotation: number;
};

export type ArtLayer = {
  imageId: string;
  name: string;
  visible: boolean;
  transform: ArtTransform | null; // null fits the image to the canvas
};

export type CustomArt = Omit<ArtLayer, "transform"> & {
  image: HTMLImageElement;
  transform: ArtTransform;
};

export function fitArt(image: HTMLImageElement): ArtTransform {
  const scale = 1080 / image.naturalHeight;
  const width = image.naturalWidth * scale;
  const height = image.naturalHeight * scale;
  return { x: 0, y: 0, width, height, scaleX: 1, scaleY: 1, rotation: 0 };
}
